// extracted by mini-css-extract-plugin
export default {"toggle":"NavigationToggle_toggle__DC3fR","button":"NavigationToggle_button__DmC6J"};